import ApiService from 'services/index';
import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap'; 
import { getLiveScoreLink } from 'utils/links';

function LiveMatches() {
    const [liveMatches, setLiveMatches] = useState([]);
    const [showLiveMatches, setShowLiveMatches] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            // Flag to track if an API call is in progress
            let isFetchingData = false;

            try {
                if (!isFetchingData) {
                    // Set the flag to indicate that an API call is in progress
                    isFetchingData = true;

                    let response = await ApiService.getLiveMatchData();
                    if (response && response.live && response.live.length) {
                        const matches = response.live;
                        if (matches) {
                            setLiveMatches(matches);
                        }
                    }
                    // Reset the flag when the API call is completed
                    isFetchingData = false;
                }
            } catch (error) {
                // Handle error
                console.log(error);
            }
        };
        fetchData();
        const intervalId = setInterval(fetchData, 15000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const handleMatchClick = (matchId) => {
        // Navigate to the live match page with the matchId
        window.location.href = `/live/coverage/${matchId}`;
    };

    const toggleLiveMatches = () => {
        setShowLiveMatches(!showLiveMatches);
    };

    return (
        <Container>


            <Row>
                <Col xs={12}>
                    {liveMatches && liveMatches.length > 0 && <div className="live-matches-header">
                        Live Matches
                        <Button
                            className="d-md-none text-right"
                            onClick={toggleLiveMatches}
                        >
                            {showLiveMatches ? 'Hide' : 'Show'}
                        </Button>
                    </div>
                    }
                </Col>
            </Row>

            {showLiveMatches && (
                <Row id="live-matches" className='justify-content-center mb-2'>

                    {liveMatches.map((liveData) => {
                        const parsedData = JSON.parse(liveData.live_data);
                        const i1p = parsedData.innings.inn1.bat === parsedData.meta.tm1Id ? 't1' : 't2';
                        const i2p = parsedData.innings.inn1.bat === parsedData.meta.tm1Id ? 't2' : 't1';
                        const inn1Score = `${parsedData.fullMatch.match[i1p + 'Sc']}/${parsedData.fullMatch.match[i1p + 'Wkt']} (${parsedData.fullMatch.match[i1p + 'DispOv']})`;
                        const inn2Score = parsedData.summary.inn === 1
                            ? ''
                            : `${parsedData.fullMatch.match[i2p + 'Sc']}/${parsedData.fullMatch.match[i2p + 'Wkt']} (${parsedData.fullMatch.match[i2p + 'DispOv']})`;

                        const liveContent = parsedData.meta.matchOver ? '' : <span className="live fw-bold">Live </span>;

                        return (
                            <Col xs={12} md={6} lg={3} key={liveData.id} className="live-match border p-3" data-matchid={parsedData.meta.id} onClick={() => handleMatchClick(parsedData.meta.id)}>
                                <div className="live-match-team">
                                    <span className="live-team">{parsedData.innings.inn1.batname}</span>
                                    <span className="live-score1 fw-bold" dangerouslySetInnerHTML={{ __html: inn1Score }} />
                                </div>
                                <div className="live-match-team">
                                    <span className="live-team">{parsedData.innings.inn2.batname}</span>
                                    <span className="live-score2 fw-bold" dangerouslySetInnerHTML={{ __html: inn2Score }} />
                                </div>
                                <div>
                                    {liveContent}
                                    {parsedData.summary.eq ? parsedData.summary.eq : ''}
                                </div>
                            </Col>
                        );
                    })}
                </Row>

            )}
        </Container>
    );
}

export default LiveMatches;
